import { render } from "./App.vue?vue&type=template&id=251f3140"
const script = {}

import "./App.vue?vue&type=style&index=0&id=251f3140&lang=css"

import exportComponent from "F:\\project\\TrainPlatform\\trunk\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__